import React from 'react';

const GradientSpinnerIcon = ({ ...rest }) => {
  return (
    <svg 
      className="spinner-icon" 
      width="16" 
      height="16" 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      {...rest}
    >
      {/* Background circle with #D1D4EC color */}
      <circle 
        cx="8" 
        cy="8" 
        r="8" 
        fill="#D1D4EC"
        opacity="0.3"
      />
      
      {/* Gradient spinner arc */}
      <path 
        d="M16 8C16 6.41775 15.5308 4.87103 14.6518 3.55544C13.7727 2.23984 12.5233 1.21446 11.0615 0.608964C9.59966 0.00346267 7.99113 -0.154964 6.43928 0.153718C4.88743 0.4624 3.46197 1.22433 2.34315 2.34315C1.22433 3.46197 0.4624 4.88743 0.153718 6.43928C-0.154964 7.99113 0.00346269 9.59966 0.608964 11.0615C1.21446 12.5233 2.23985 13.7727 3.55544 14.6518C4.87103 15.5308 6.41775 16 8 16V13.3366C6.94453 13.3366 5.91276 13.0236 5.03517 12.4372C4.15758 11.8508 3.47358 11.0173 3.06967 10.0422C2.66576 9.06708 2.56008 7.99408 2.76599 6.95889C2.9719 5.9237 3.48016 4.97282 4.22649 4.22649C4.97282 3.48016 5.9237 2.9719 6.95889 2.76599C7.99408 2.56008 9.06708 2.66576 10.0422 3.06967C11.0173 3.47358 11.8508 4.15758 12.4372 5.03517C13.0236 5.91276 13.3366 6.94453 13.3366 8H16Z" 
        fill="url(#spinner-gradient)"
      />
      <defs>
        <linearGradient 
          id="spinner-gradient" 
          x1="2.27497" 
          y1="-34.5393" 
          x2="42.3118" 
          y2="-18.6286" 
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF0078"/>
          <stop offset="0.06" stopColor="#E80089"/>
          <stop offset="0.2" stopColor="#AD00B4"/>
          <stop offset="0.35" stopColor="#6200EB"/>
          <stop offset="0.66" stopColor="#05D1CE"/>
          <stop offset="1" stopColor="#007DEB"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default GradientSpinnerIcon;